// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// require('./idb/index.js')
require('./mdl/index.js')
require('./polyfills/includes.js')
require('./polyfills/math.js')
require('es6-promise').polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import idb from 'idb'

const isLocalhost = Boolean(window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
)

Vue.config.productionTip = false
Vue.prototype.$loading = { show: () => {} }
Vue.prototype.$dialog = {}
Vue.prototype.$toast = {}
Vue.prototype.$snackbar = {}
Vue.prototype.$actionbar = { init: () => {}, destroy: () => {} }
Vue.prototype.$user = {}
Vue.prototype.$title = {}
Vue.prototype.$endpoint = {}
Vue.prototype.$http = axios.create({
  baseURL: isLocalhost ? 'http://localhost:8081/api' : 'https://appauditoria.gtglobal.com/api',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  validateStatus: function (status) {
    return true
    // return status >= 200 && status < 300
    //   || Vue.prototype.$toast.show('¡Algo sucedió! No se pudó conectar al servidor.')
  }
})

Vue.prototype.$idb = {
  'dbPromise': idb.open('gt-global', 1, upgradeDB => {
    switch (upgradeDB.oldVersion) {
      case 0:
        upgradeDB.createObjectStore('login', {keyPath: 'id'})

        let empresas = upgradeDB.createObjectStore('empresas', {keyPath: 'id'})
            empresas.createIndex('id', 'id')
            empresas.createIndex('padreId', 'padreId')

        let unidadesNegocio = upgradeDB.createObjectStore('unidades-negocio', {keyPath: 'id'})
            unidadesNegocio.createIndex('id', 'id')
            unidadesNegocio.createIndex('padreId', 'padreId')

        let inmuebles = upgradeDB.createObjectStore('inmuebles', {keyPath: 'id'})
            inmuebles.createIndex('id', 'id')
            inmuebles.createIndex('padreId', 'padreId')
            inmuebles.createIndex('activo', 'activo')

        upgradeDB.createObjectStore('areas', {keyPath: 'id'}).createIndex('padreId', 'padreId')
        upgradeDB.createObjectStore('rubros', {keyPath: 'id'}).createIndex('padreId', 'padreId')

        let tree = upgradeDB.createObjectStore('tree', {keyPath: 'id', autoIncrement: true})
            tree.createIndex('id', 'id')
    }
  }),
  'keyVal': {
    get(ObjectStoreName, key) {
      return Vue.prototype.$idb.dbPromise.then(db => {
        return db.transaction(ObjectStoreName)
          .objectStore(ObjectStoreName).get(key)
      })
    },
    getOnly(ObjectStoreName, index, key) {
      return Vue.prototype.$idb.dbPromise.then(db => {
        const values = []
        return db.transaction(ObjectStoreName, 'readonly')
          .objectStore(ObjectStoreName)
          .index(index)
          .openCursor(IDBKeyRange.only(key))
          .then( function log(cursor) {
            if (!cursor) return
            // console.log("Cursored at:", cursor.value)
            values.push(cursor.value)
            return cursor.continue().then(log)
          })
          .then(() => values)
      })
    },
    getAll(ObjectStoreName) {
      return Vue.prototype.$idb.dbPromise.then(db => {
        return db.transaction(ObjectStoreName)
          .objectStore(ObjectStoreName).getAll()
      })
    },
    set(ObjectStoreName, key, val) {
      return Vue.prototype.$idb.dbPromise.then(db => {
        const tx = db.transaction(ObjectStoreName, 'readwrite')
        tx.objectStore(ObjectStoreName).put(val, key)
        return tx.complete
      })
    },
    deleteOnly(ObjectStoreName, index, key) {
      return Vue.prototype.$idb.dbPromise.then(db => {
        let deleted = 0
        return db.transaction(ObjectStoreName, 'readwrite')
          .objectStore(ObjectStoreName)
          .index(index)
          .openCursor(IDBKeyRange.only(key))
          .then( function log(cursor) {
            if (!cursor) return
            return cursor.delete(cursor.primaryKey)
              .then(event => {
                deleted += 1
                return cursor.continue().then(log)
              })
              .catch(event => {
                return cursor.continue().then(log)
              })
          })
          .then(() => deleted)
      })
    },
    delete(ObjectStoreName, key) {
      return Vue.prototype.$idb.dbPromise.then(db => {
        const tx = db.transaction(ObjectStoreName, 'readwrite')
        tx.objectStore(ObjectStoreName).delete(key)
        return tx.complete
      })
    },
    clear(ObjectStoreName) {
      return Vue.prototype.$idb.dbPromise.then(db => {
        const tx = db.transaction(ObjectStoreName, 'readwrite')
        tx.objectStore(ObjectStoreName).clear()
        return tx.complete
      })
    },
    keys(ObjectStoreName) {
      return Vue.prototype.$idb.dbPromise.then(db => {
        const tx = db.transaction(ObjectStoreName)
        const keys = []
        const store = tx.objectStore(ObjectStoreName)

        // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
        // openKeyCursor isn't supported by Safari, so we fall back
        (store.iterateKeyCursor || store.iterateCursor).call(store, cursor => {
          if (!cursor) return
          keys.push(cursor.key)
          cursor.continue()
        })

        return tx.complete.then(() => keys)
      })
    }
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js